import { Link } from "@tanstack/react-router";
import { buttonClass } from "../../components/ui/Button";

export function NotFoundPage() {
  return (
    <div className="mx-auto max-w-md px-6 py-16 text-center">
      <h1 className="text-2xl font-semibold text-ink">Page not found</h1>
      <p className="mt-2 text-ink-2">The link may be old, or the document was moved or archived.</p>
      <Link to="/" className={buttonClass({ variant: "primary" }, "mt-6")}>
        Back to the start page
      </Link>
    </div>
  );
}
